// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"246":"03fa1dc4c6c56e62","454":"c7b0164b9ba7edb5"}[chunkId] + ".css";
};